<app-barra-consulta
  *ngIf="!carregando"
  visible="false"
  [listagemComFiltros]="getListagemComFiltros()"
  (atualizando)="atualizar($event)"
  (inserindo)="novo($event)"
  (definirFiltro)="definirFiltragem()"
  [exibirNovo]="exibirBotaoNovo"
  [exibirBotaoAjuda]="exibirBotaoAjuda"
  [exibirBarraCor]="exibirBarraCor"
  [exibirBotaoDefinirFiltros]="exibirBotaoDefinirFiltros">
</app-barra-consulta>

<div *ngIf="!carregando" class="row" style="margin: 5px 15px 5px 15px;">
  <div class="col col-12 text-right">
    <button
      type="button"
      class="btn btn-outline-secondary btn-sm"
      (click)="exportExcel()">
      <i class="fa fa-download"></i>
      Export Excel
    </button>
  </div>
</div>

<div class="conteudo">
  <app-loading [exibir]="carregando"></app-loading>

  <div *ngIf="!carregando">
    <app-gridview
      [ExibirIconBotaoDetalhes]="exibirIconBotaoDetalhes"
      [ExibirBotaoDetalhes]="exibirBotaoDetalhes"
      [ExibirBotaoDetalhesIcon]="exibirBotaoDetalhesIcon"
      [NomeModulo]="nomeModulo"
      [totalInterna]="visualizarTotalInterna"
      [totalGeral]="visualizarTotalGeral"
      [visualizarTotalRegistros]="visualizarTotalRegistros"
      [PaginaAtual]="paginaAtual"
      [QuantidadeRegistrosPorPagina]="quantidadeRegistrosPorPagina"
      [Paginacao]="listagemComPaginacao"
      [Estrutura]="estrutura"
      [Dados]="dados"
      [Borda]="false"
      [EstruturaInterna]="estruturaInterna"
      [EstruturaTotal]="estruturaTotal"
      [total_registros]="total_registros"

      (ver)="ver($event)"
      (mudarQuantidadePorPagina)="mudarQuantidadePorPagina($event)"
      (mudarPaginaAtual)="mudarPaginaAtual($event)">
    </app-gridview>
  </div>
</div>